/*
 * Adapter for VK.com Retargeting
 */

export const channelEvents = {
  PageView: () => {
    return [[]];
  },
};
